import {
    FETCH_BOOKING_LOCATION,
    FETCH_BOOKING_LOCATION_SUCCESS,
    FETCH_BOOKING_LOCATION_FAILED,
    STOP_LOCATION_FETCH,
    STORE_ADRESSES
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { query, onValue, set, off, push, limitToLast } from "firebase/database";
import getCurrentUid from '../other/getCurrentUid';
import { safeSet } from '../other/firebaseDbHelper';
import { GetDistance } from '../other/GeoFunctions';

// S6 (2026-05-26): throttle tracking writes per booking. Each tracking push triggers RTDB
// egress not just for the write itself but for every onValue listener subscribed to
// tracking/{bookingId} (customer's BookedCabScreen + admin Dashboard map). High-frequency
// driver GPS samples (1-3 s) compound that cost. 15 s gives ~200 m granularity at 50 km/h,
// which matches industry norm for delivery tracking UX.
const TRACKING_MIN_INTERVAL_MS = 15_000;
const _lastTrackingPush = new Map(); // bookingId -> wall-clock ms of last successful push

// RTDB cost guard: locations/{uid} is used for live driver availability and admin maps.
// The app can receive native GPS updates several times per second; writing every sample
// creates unnecessary RTDB write/listener churn. A 15s/20m gate keeps the map fresh while
// reducing the live profiler's observed ~1-3 writes/sec/driver pattern.
const USER_LOCATION_MIN_INTERVAL_MS = 15_000;
const USER_LOCATION_MIN_DISTANCE_KM = 0.02;
const _lastUserLocationPush = new Map(); // uid -> { at, lat, lng }

export const saveTracking = (bookingId, location) => {
    if (!bookingId) return;
    const now = Date.now();
    const last = _lastTrackingPush.get(bookingId) || 0;
    if (now - last < TRACKING_MIN_INTERVAL_MS) {
        return; // drop sample — too soon since last write
    }
    const {
        trackingRef
    } = firebase;
    _lastTrackingPush.set(bookingId, now);
    push(trackingRef(bookingId), location);
}

export const fetchBookingLocations = (bookingId) => (dispatch) => {

    const {
        trackingRef
    } = firebase;

    dispatch({
        type: FETCH_BOOKING_LOCATION,
        payload: bookingId,
    });
    onValue(query(trackingRef(bookingId), limitToLast(1)),(snapshot) => {
        if (snapshot.val()) {
            let data = snapshot.val();
            const locations = Object.keys(data)
                .map((i) => {
                    return data[i]
                });
            if (locations.length == 1) {
                dispatch({
                    type: FETCH_BOOKING_LOCATION_SUCCESS,
                    payload: locations[0]
                });
            }
            else {
                dispatch({
                    type: FETCH_BOOKING_LOCATION_FAILED,
                    payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
                });
            }
        } else {
            dispatch({
                type: FETCH_BOOKING_LOCATION_FAILED,
                payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
            });
        }
    });
};

export const stopLocationFetch = (bookingId) => (dispatch) => {

    const {
        trackingRef
    } = firebase;

    dispatch({
        type: STOP_LOCATION_FETCH,
        payload: bookingId,
    });
    off(trackingRef(bookingId));
}

export const saveUserLocation = (location) => {
    const {
      auth,
      userLocationRef,
    } = firebase;
    const uid = getCurrentUid(auth);
    if (!uid) return;

    const lat = Number(location?.lat);
    const lng = Number(location?.lng);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return;
    }

    const now = Date.now();
    const last = _lastUserLocationPush.get(uid);
    if (last) {
        const elapsed = now - last.at;
        const distance = GetDistance(last.lat, last.lng, lat, lng);

        if (elapsed < USER_LOCATION_MIN_INTERVAL_MS || distance < USER_LOCATION_MIN_DISTANCE_KM) {
            return;
        }
    }

    _lastUserLocationPush.set(uid, { at: now, lat, lng });
    safeSet(userLocationRef(uid),location);
}

export const storeAddresses = (data) => (dispatch) => {
    dispatch({
        type: STORE_ADRESSES,
        payload: data,
    });
}
